import { GabaritNavigationUtil } from "../../../utils/gabarit-navigation/GabaritNavigationUtil";
import { LangueUtils } from "@oel/js-i18n";
import { en } from "./i18n/Transactions.i18n.en";
import { fr } from "./i18n/Transactions.i18n.fr";
import { useEffect } from "react";
import { IdPageEnum } from "../../../utils/gabarit-navigation/IdPageEnum";

export function Transactions() {

    const libelles = new LangueUtils(fr, en).obtenirLibelles();

    useEffect(() => {
        document.title = libelles.titreOnglet;
        GabaritNavigationUtil.afficherGabarit(IdPageEnum.TRANSACTIONS_ADP);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <operations-centralisees />
        </div>
    );
}
